// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"v0-z"};